import React from "react";
import { PageDescription, PageTitle } from "../../components";
import FilterList from "./FilterList";
import { Anchor } from "discover.medical.react-component-library";
import { Link } from "react-router-dom";

// TODO: make this a generic component to keep the template generic.
// Href and link text can be added on to the metadata API response like we do with placards.
const BackLink = () => (
  <Anchor
    className="leadershipAnchor"
    href="/browse/leadership"
    linkComponent={Link}
    glyph="navigate_next"
    floatLeft={false}
    glyphColor="secondary"
    fontWeight="bold"
    marginBottom="md"
  >
    Leadership
  </Anchor>
);

const ListTemplate = ({
  title,
  description,
  browsePath,
  topics,
  excludedContent,
}) => {
  return (
    <>
      {browsePath.includes("leadership/") && <BackLink />}
      <PageTitle>{title}</PageTitle>
      <PageDescription>{description}</PageDescription>
      <FilterList
        data={topics}
        label={title}
        excludedContent={excludedContent}
      />
    </>
  );
};

export default ListTemplate;
